{
  "code": "EX-00",
  "APP": "P360° Mobile",
  "@COMMON": "Common information for translation",
  "COMPANY_TYPE": "Default",
  "EMPTY": "",
  "NONE": "",
  "ALL": "Todos",

  "ACCEPT": "Aceptar",
  "ADDRESS": "Dirección",
  "ADDRESS_PLACEHOLDER": "Ingresa la dirección",
  "APPOINTMENT": "Visita",
  "APPOINTMENT_SAMPLE_INFORMATION": "Entrega de muestras",
  "APPOINTMENT_STOCK_INFORMATION": "Toma de Stock",
  "APPOINTMENT_FACE_INFORMATION": "Registro de Caras",
  "APPOINTMENT_TRAINING_INFORMATION": "Registro de Capacitación",
  "APPOINTMENT_TRAINING_PERSON_INFORMATION": "Contactos y stakeholders",
  "APPOINTMENT_DISPLAY_INFORMATION": "Registro de Exhibición",
  "APPOINTMENT_HISTORY": "Histórico de Visitas",
  "APPOINTMENTS": "Visitas",
  "APPOINTMENT_DETAILS": "Detalles de la Visita",
  "AUSTRO": "Austro",
  "BONIF_WITH_LABEL": "Bnf({{type}})",
  "BONIF_WITH_LABEL_PERCENT": "%Bnf({{type}})",
  "CANCEL": "Cancelar",
  "CATEGORY": "Categoría",
  "CATEGORY_SPECIALTY": "Categoría / Especialidad",
  "CATEGORY_PLACEHOLDER": "Selecciona la categoría",
  "CHANGE_PASSWORD": "Cambia tu contraseña",
  "CITY": "Ciudad",
  "CLEAR_ALL": "Limpiar Todo",
  "CLIENT": "Cliente",
  "CODE": "Código",
  "CODE_DISTRIB": "Código",
  "CONTACT_PLACEHOLDER": "Ingresa la información de contacto",
  "COLLABORATOR": "Representante",
  "COMMENTS": "Observaciones",
  "GENERAL_COMMENTS_WITH": "Observaciones generales {{value}}",
  "COMMENTS_PLACEHOLDER": "Ingresa comentarios adicionales",
  "GENERAL_COMMENTS_PLACEHOLDER_WITH": "Ingresa las observaciones generales de {{value}}",
  "COMPANIONS": "Acompañantes",
  "COMPANY": "Compañía",
  "COMPANY_PLACEHOLDER": "Ingresa la Compañía",
  "CONCENTRATION_WITH_LABEL": "Concentración {{type}}",
  "CONTINUE": "Continuar",
  "COSTA": "Costa",
  "COUNTRY": "País",
  "CUSTOMER": "Cliente",
  "CUSTOMER_HEADING": "Médico o PDC",
  "CUSTOMER_NUMBER": "Número Fiscal",
  "CUSTOMER_NUMBER_PLACEHOLDER": "Ingresa el número fiscal",
  "CUSTOMER_TOP": "Cliente (Top {{top}})",
  "CUSTOMER_TYPE": "Tipo de Cliente",
  "CUSTOMERS": "Clientes",
  "CYCLE": "Ciclo",
  "DATE": "Fecha",
  "DATE_LENGTH": "Dur.(min)",
  "DATE_TYPE_CUMULATIVE": "Acumulado a",
  "DATE_TYPE_CUMULATIVE_SHORT": "Ytd",
  "DATE_TYPE_MONTHLY": "Al mes",
  "DATE_TYPE_MONTHLY_SHORT": "Mes",
  "DATE_TYPE_MAT": "MAT",
  "DATE_TYPE_MAT_SHORT": "MAT",
  "DATETIME": "Fecha & Hora",
  "TIME": "Hora",
  "DEPENDENT": "Dependiente",
  "DEPENDENTS": "Capacitados",
  "DESCRIPTION": "Descripción",
  "DOCTOR": "Médico",
  "DRUGSTORE": "Farmacia",
  "EMAIL": "Correo Electrónico",
  "EMAIL_PLACEHOLDER": "Ingresa el correo electrónico",
  "EN": "English",
  "ES": "Español",
  "FILTERS_OR": "o",
  "FILTERS_TITLE": "Opciones de Filtro",
  "FILTERS_TITLE_REGISTRY": "Filtros del fichero",
  "FORMAT": "Formato",
  "FREQUENCY": "Frecuencia",
  "FREQUENCY_COMPLETED": "Frec. Cumplida",
  "FULFILLMENT_WITH_LABEL": "%C({{type}})",
  "GENERAL_ADDRESS_INFORMATION": "Información general ubicación",
  "GENERAL_PHOTO": "Captura Gráfica de la {{type}}",
  "GLOBAL_GROUP": "Grupo Cadena",
  "GLOBAL_GROUP_PLACEHOLDER": "Selecciona el grupo cadena",
  "GROUP": "Grupo",
  "GROUP_PLACEHOLDER": "Selecciona el grupo",
  "IE": "IE",
  "INFORMATION": "Información",
  "ITEM": "Ítem",
  "ITEMS_UOM": "Ítems (U)",
  "ITEMS_UOM_LOWER": "ítems (U)",
  "LAB_ACT": "Lab Act",
  "LAB_ANT": "Lab Ant",
  "LANGUAGE": "Idioma",
  "LINES": "Líneas",
  "LOGOUT": "Cerrar sesión",
  "MAT": "MAT",
  "MAT_WITH_LABEL": "MAT({{type}})",
  "MDO_ACT": "Mdo Act",
  "MEASURE": "Medida",
  "MEASURE_ABS": "RX(U)",
  "MEASURE_PERCENT": "Msh(%)",
  "MEASURE_QTD": "QTD",
  "MEASURE_MAT": "MAT",
  "MEASURE_MLY": "MLY",
  "MEASURE_MTD": "MTD",
  "MEASURE_TRI": "TRI",
  "MEASURE_YTD": "YTD",
  "MEDIC": "Médico",
  "MINE": "Míos",
  "MSH_ACT": "Msh Act",
  "MSH_ANT": "Msh Ant",
  "MTH": "MTD",
  "NAME": "Nombre",
  "NAME_PLACEHOLDER": "Ingresa el Nombre",
  "NEW_CLIENT": "Agregar nuevo cliente",
  "NEW_CUSTOMER_INFORMATION": "El registro de un nuevo Cliente, será sometido a un proceso de validación en el Pipeline de Clientes y será sujeto a revisión para su adición definitiva en el catálogo empresarial de Clientes y contactos válidos",
  "NO": "No",
  "NOT_VISITED": "No Visitado",
  "FREQ_COMPLETED": "Frc. ya cumplida",
  "FREQ_NOT_COMPLETED": "Frc. no cumplida",
  "ONE": "Uno",
  "ORDER": "Pedido",
  "ORDER_DETAILS": "Productos del pedido",
  "ORDERS": "Pedidos",
  "PHONE": "Teléfono",
  "PLAN_WITH_ICON": "Plan(<i class=\"{{icon}}\"></i>)",
  "PLAN_WITH_LABEL": "Plan({{type}})",
  "PLAN_WITH_LABEL_ACU": "Plan Acu({{type}})",
  "PRECISION": "Precisión",
  "PREVIOUS": "Ant",
  "PROFILE": "Perfil",
  "PROJECTION": "(+/-) Venta",
  "QTD": "QTD",
  "QUANTITY": "Cantidad",
  "RAPID_FILTER": "Análisis Jerárquico",
  "RECIPE": "Recetaria",
  "REFRESH_INFO": "Refrescar Información",
  "REFERENCE": "Referencia",
  "REGION": "Región",
  "SALES": "Ventas",
  "SALES_WITH_ICON": "Venta(<i class=\"{{icon}}\"></i>)",
  "SALES_WITH_LABEL": "Venta({{type}})",
  "SALES_WITH_LABEL_ACU": "Venta Acu({{type}})",
  "SALES_WITH_LABEL_PREV": "Venta({{type}}){{textExp}}",
  "SEE_ALL": "Ver todo",
  "SEE_ALL_DETAILS": "Ver todo el detalle",
  "SEND": "Enviar",
  "SIERRA": "Sierra",
  "SOCIAL_MEDIA_INFORMATION": "Información de redes sociales",
  "SPECIALTY": "Especialidad",
  "TARGET": "Objetivo",
  "TARGET_OF": "Objetivo de {{value}}",
  "TOWN": "Población",
  "TOWN_PLACEHOLDER": "Selecciona la población",
  "TURN_NUMBER": "Número de turno",
  "TWO": "Dos",
  "TYPE_DOLLAR": "Dólares",
  "TYPE_UNITS": "Unidades",
  "VISITED": "Visitado",
  "YES": "Si",
  "ZERO": "Cero",
  "ORDER_HISTORY": "Histórico de Pedidos",

  "ADD": "Agregar",
  "EDIT": "Editar",
  "STOCK_LABEL": "Reportado",
  "STOCK_REQUIRED_QTY": "Mínimo reposición",
  "STOCK_REAL_QTY": "Real encontrado",
  "SUGGESTED": "Sugerido",
  "NEWS": "Novedades",
  "ACTION": "Acción",
  "TOTAL": "Total",
  "PLACEHOLDER_CLIENT": "Ingrese el nombre del cliente",
  "PLACEHOLDER_CONTACT": "Ingrese el nombre de contacto",
  "PLACEHOLDER_COMMENTS": "Observaciones del {{value}}",
  "PLACEHOLDER_DEPENDENT": "Ingrese el nombre de dependiente",
  "PLACEHOLDER_ITEM": "Seleccione el ítem",
  "QTY": "Qty",
  "CURRENT": "Planograma",
  "WIN": "Ganadas",
  "FACE_LOCATION": "Ubicación Caras",
  "FACE_NEW_LOCATION": "Las caras se ganaron en el mes?",
  "PHOTO_BEFORE": "Antes",
  "PHOTO_AFTER": "Después",
  "DEPENDENTS_NUMBER": "Capacitados",
  "HIT": "Tipo de Impacto",
  "MATERIAL": "Tipo de Material",
  "PHOTO": "Evidencia",
  "DISPLAY": "Tipo de Exhibición",
  "DISPLAY_WIN": "Exhibiciones",
  "DISPLAY_LOCATION": "Ubicación Exhibiciones",
  "DISPLAY_NEW_LOCATION": "La Exhibición se ganó en el mes?",
  "DISPATCHER": "Distribuidor",
  "DELIVERY_DATE": "Fecha estimada entrega",
  "PAYMENT_DATE": "Fecha estimada pago",
  "BONIF": "Bonif. (U)",
  "BONIF_LOWER": "bonif. (U)",
  "BONIFICATION": "Bonificación",
  "PVF": "PVF",
  "PVP": "PVP",
  "DISC": "Dsc",
  "DISCOUNT": "Descuento",

  "CATEGORY_SHORT": "Cat./Esp.",
  "CUSTOMER_PLACEHOLDER": "Selecciona un cliente",
  "NEXT_APPOINTMENT_DATE": "Fecha siguiente visita",
  "NEXT_APPOINTMENT_DATE_SHORT": "Sig. visita",
  "APPOINTMENT_NEXT_DATE": "Fecha acordada siguiente visita",
  "THE_APPOINTMENT": "la visita",
  "THE_ORDER": "el pedido",
  "COMMENTS_WITH": "Observaciones de {{value}}",
  "VIEWED_COMMENTS": "Observaciones y retroalimentación del visitado",
  "VIEWED_COMMENTS_SHORT": "Observaciones del visitado",
  "COMMITMENT": "Compromiso efectuado",
  "REASON": "Motivo de la visita",
  "REASON_OF": "Motivo de {{value}}",
  "TYPE_OF": "Tipo de {{value}}",
  "NEWS_OF": "Novedades de {{value}}",

  "FINISHED": "Cumplida",
  "GOAL": "Meta",
  "SEE_MORE": "Ver más",

  "QUINTIL": "Quintil",

  "SYNC": "Sincronizar",

  "APPOINTMENT_DATE": "Fecha visita",
  "APPOINTMENT_COMMERCIAL_ACTIONS": "Acciones comerciales ejecutadas",
  "APPOINTMENT_HAS_ORDER": "Pedido",
  "APPOINTMENT_HAS_TRAINING": "Capacitación",
  "APPOINTMENT_HAS_FACE": "Caras",
  "APPOINTMENT_HAS_DISPLAY": "Exhibiciones",
  "APPOINTMENT_HAS_STOCK": "Stock",
  "APPOINTMENT_HAS_ITEM_SAMPLE": "Muestras",
  "APPOINTMENT_STATUS": "Estado visita",
  "PLANNING_VERSION": "Versión fichero",

  "ORDER_DATE": "Fecha pedido",
  "ORDER_TOTAL_QUANTITY": "Total (U)",
  "ORDER_TOTAL_SENT": "Total desp. (U)",
  "ORDER_TOTAL_AWAITING": "Pendiente desp. (U)",
  "ORDER_PVF": "Valor venta",
  "ORDER_DISCOUNT": "Desc.(%)",
  "ORDER_TOTAL": "Valor final",

  "PRE_ORDER_TITLE": "Smart Order P360°",
  "PRE_ORDER_DROPDOWN": "Tipo de pedido automático",

  "DELETE": "Eliminar",

  "@SETTINGS": "Settings section",
  "SETTINGS_HEADER": "Configuración",
  "SETTINGS_UNITS": "U / $ (Ej: $123,456.56)",
  "SETTINGS_THOUSANDS": "Miles (Ej: 123.4k)",
  "SETTINGS_MILLIONS": "Millones (Ej: 1.23M)",

  "@LOGIN": "Login section",
  "LOGIN_DESCRIPTION": "Bienvenido a <span class=\"text-bold\">P360° Mobile</span>, donde la magia empieza, inicia sesión para continuar. O crea una cuenta <a class=\"text-primary\" href=\"/registro\">aquí</a>",
  "LOGIN_FORGOT_PASSWORD": "Olvidé mi contraseña.",
  "LOGIN_FORGOT_PASSWORD_MODAL": "Ingresa tu correo electrónico para restablecer tu contraseña.",
  "PASSWORD": "Contraseña",
  "LOGIN": "Ingresar",
  "RESTORE": "Recuperar",

  "@REGISTER": "Register section",
  "REGISTER_DESCRIPTION": "Para crear tu usuario debes ingresar <span class=\"font-bold\">toda</span> la siguiente información requerida",
  "REGISTER": "Registrar",
  "WORK_EMAIL": "Correo electrónico empresarial",
  "DOCUMENT_ID": "Cédula de identidad",
  "NAMES": "Nombres",
  "LASTNAMES": "Apellidos",

  "@PRINCIPAL": "Principal Screen",
  "PRINCIPAL_PERSONALIZE_YOUR_VIEW": "Personaliza tu vista aquí:",
  "PRINCIPAL_YOUR_NUMBERS": "KPIs (Balanced Scorecard)",
  "PRINCIPAL_YOUR_NUMBERS_LEVEL": "KPIs de {{kpi}} (level {{level}})",

  "@PERFORMANCE": "Performance Screen",
  "PERFORMANCE_COLLABORATOR_SELECTOR": "Ver rendimiento...",
  "PERFORMANCE_HEADLINE": "Cumplimiento de <b class=\"text-primary text-italic\">{{date}}</b> de Ventas por Productos en <b class=\"text-primary text-italic\">{{formatType}}</b> (%)",
  "PERFORMANCE_SUBHEADLINE": "APM: <span class=\"font-bold text-primary\">{{agentName}}</span> ({{agentCode}})",
  "PERFORMANCE_RANKING": "Pos Cump: {{ranking}}",
  "PERFORMANCE_PRODUCT_TOP": "Top {{quantity}} Productos",
  "PERFORMANCE_PRODUCT_ANNUAL_TREND": "Tendencia anual - Top {{quantity}} Productos",
  "PERFORMANCE_PRODUCT_ANNUAL_TREND_SELECTED": "Tendencia anual - Para producto <span class=\"text-primary\">{{product}}</span>",
  "PERFORMANCE_PRODUCT_ANNUAL_PIE_CHART_TITLE": "Composición de ventas de productos en multi-Periodos",
  "PERFORMANCE_CLIENT_TOP": "Top {{quantity}} Clientes para el producto: <span class=\"text-primary\">{{product}}</span>",
  "PERFORMANCE_CLIENT_ANNUAL_TREND": "Tendencia anual - Top {{quantity}} Clientes para el producto: <span class=\"text-primary\">{{product}}</span>",
  "PERFORMANCE_CLIENT_ANNUAL_TREND_SELECTED": "Tendencia anual - Para el producto: <span class=\"text-primary\">{{product}}</span>, para cliente <span class=\"text-primary\">{{client}}</span>",
  "PERFORMANCE_CLIENT_ANNUAL_PIE_CHART_TITLE": "Composición de ventas de clientes en multi-Periodos",
  "PERFORMANCE_ALL_PRODUCTS": "Todos los Productos",
  "PERFORMANCE_FULFILLMENT": "Cumplimiento de <b class=\"text-primary text-italic\">{{date}}</b> de Ventas por Productos en <b class=\"text-primary text-italic\">{{formatType}}</b> (%)",
  "PERFORMANCE_FULFILLMENT_BY_CC": "Cumplimiento ventas por <b>{{selection}}</b> para el producto: <b class=\"text-primary\">{{product}}</b>",

  "@CRM_CUSTOMER_CATALOG": "CRM - Customer Catalog Screen",
  "CRM_CUSTOMER_CATALOG_HEADLINE": "Resumen general de visita en perspectiva fichero médico & PDC",
  "CRM_CUSTOMER_CATALOG_HEADLINE_COLLAB": "Colaborador: <span class=\"font-bold text-primary\">{{collaborator}}</span>",
  "CRM_CUSTOMER_CATALOG_SUBHEADLINE": "<span class=\"font-bold text-primary\">{{dateFilter}}</span>",
  "CRM_CUSTOMER_CATALOG_CHART_TITLE": "Médicos & PDC fichero x Especialidad/Categoría",
  "CRM_CUSTOMER_CATALOG_METRICS_1": "Médicos & PDC asignados en fichero",
  "CRM_CUSTOMER_CATALOG_METRICS_2": "Médicos & PDC Total Frec.",
  "CRM_CUSTOMER_CATALOG_METRICS_3": "Médicos & PDC ya visitados",
  "CRM_CUSTOMER_CATALOG_METRICS_4": "Visitas & revisitas Frec. efectuadas",
  "CRM_CUSTOMER_CATALOG_METRICS_5": "Médicos & PDC aún no visitados",
  "CRM_CUSTOMER_CATALOG_METRICS_6": "Médicos & PDC Frec. ya cumplida",
  "CRM_CUSTOMER_CATALOG_METRICS_7": "Médicos & PDC Frec. no cumplida",
  "CRM_CUSTOMER_CATALOG_METRICS_8": "Cump. Visitas vs Fichero (%)",
  "CRM_CUSTOMER_CATALOG_METRICS_9": "Cump. Frec. (%)",

  "@CRM_CUSTOMER_DETAIL": "CRM - Customer Detail Screen",
  "CRM_CUSTOMER_DETAIL_CLIENT_HEADLINE": "Resumen Ventas al MAT, corte a <span class=\"font-bold text-primary\">{{dateFilter}}</span>",
  "CRM_CUSTOMER_DETAIL_DRUGSTORE_HEADLINE": "Resumen Rotación al MAT, corte a <span class=\"font-bold text-primary\">{{dateFilter}}</span>",
  "CRM_CUSTOMER_DETAIL_SOCIAL_MEDIA_HEADLINE": "CRM network list de <span class=\"font-bold text-primary\">{{customer}}</span>",

  "@SCHEDULE": "CRM - Calendar Screen",
  "SCHEDULE_MINE_HEADLINE": "Planificación de visita",
  "SCHEDULE_HEADLINE": "Estas viendo la planificación de colaborador: <span class=\"font-bold text-primary\">{{collaborator}}</span>",

  "@SELLIN_CUBE": "Sellin Cube Screen",
  "SELLIN_CUBE_HEADLINE": "<span class=\"font-bold text-primary\">{{measure}}</span> corte a <span class=\"font-bold text-primary\">{{dateFilter}}</span> para el cliente: <span class=\"font-bold text-primary\">{{clientSelected}}</span>",
  "SELLIN_RAPID_FILTER_SALESFORCE_LEVEL_1": "Ciudad - Línea - Producto - Ítem",
  "SELLIN_RAPID_FILTER_SALESFORCE_LEVEL_2": "Línea - Ciudad - Producto - Ítem",
  "SELLIN_RAPID_FILTER_SALESFORCE_LEVEL_3": "Línea - Producto - Ciudad - Ítem",
  "SELLIN_RAPID_FILTER_SUPERVISOR_LEVEL_1": "Región - Ciudad - Línea - Producto",
  "SELLIN_RAPID_FILTER_SUPERVISOR_LEVEL_2": "Región - Línea - Ciudad - Producto",
  "SELLIN_RAPID_FILTER_SUPERVISOR_LEVEL_3": "Línea - Región - Ciudad - Producto",
  "SELLIN_RAPID_FILTER_SUPERVISOR_LEVEL_4": "Línea - Producto - Región - Ciudad",

  "@AUDIT_SELLIN_CUBE": "Audit Cube Screen",
  "AUDIT_CUBE_RAPID_FILTER_LEVEL_1": "Línea - Supervisor - Colaborador - Segmento - Producto",
  "AUDIT_CUBE_RAPID_FILTER_LEVEL_2": "Línea - Segmento - Supervisor - Colaborador - Producto",
  "AUDIT_CUBE_COLLAB_RAPID_FILTER_LEVEL_1": "Línea - Segmento - Producto",
  "AUDIT_CUBE_COLLAB_RAPID_FILTER_LEVEL_2": "Segmento - Producto",
  "AUDIT_CUBE_RAPID_FILTER_LEVEL_3": "Colaborador - Segmento - Producto",
  "AUDIT_CUBE_RAPID_FILTER_LEVEL_4": "Segmento - Colaborador - Producto",
  "AUDIT_RX_LAB_PREV": "{{rx}}Lab{{type}} {{measure}}",
  "AUDIT_RX_MDO_PREV": "{{rx}}Mdo{{type}} {{measure}}",
  "AUDIT_PART_PREV": "MS(%) {{measure}}",
  "AUDIT_RX_LAB_CURR": "{{rx}}Lab{{type}} {{measure}}",
  "AUDIT_RX_MDO_CURR": "{{rx}}Mdo{{type}} {{measure}}",
  "AUDIT_PART_CURR": "MS(%) {{measure}}",
  "AUDIT_GROWTH_LAB": "(+/-) Lab {{measure}}",
  "AUDIT_GROWTH_MS": "(+/-) Mdo {{measure}}",

  "@CONTROL_BOARD": "Control Board Screen",
  "CONTROL_BOARD_HEADLINE": "<span>{{typeSelected}}</span> <b class=\"text-primary\">{{dateFilter}}</b>, para Línea: <b class=\"text-primary\">{{lineSelected}}</b>, de la Marca: <b class=\"text-primary\">{{brandSelected}}</b>, del Ítem: <b class=\"text-primary\">{{itemSelected}}</b>, para el Cliente: <b class=\"text-primary\">{{clientSelected}}</b>, de la Región: <b class=\"text-primary\">{{regionSelected}}</b>",
  "CONTROL_BOARD_FULFILLMENT": "<i>Cumplimiento mensualizado de ventas en <b class=\"text-primary\">{{formatType}}</b></i>",

  "@DRILLDOWN": "Drilldown Screen",
  "DRILLDOWN_HEADLINE": "Ventas en <i>{{formatType}}</i>. Información seleccionada: <b class=\"text-primary\">{{groupedTypeSelected}}</b> <b class=\"text-primary\">{{dateFilter}}</b> para el Cliente: <b class=\"text-primary\">{{clientSelected}}</b>. {{perspective}}",
  "DRILLDOWN_SALESFORCE_LEVEL_1": "Perspectiva: <b class=\"text-primary\">Supervisor</b> - Representante",
  "DRILLDOWN_SALESFORCE_LEVEL_2": "Perspectiva: Supervisor - <b class=\"text-primary\">Representante</b>, Supervisor: {{level1}}",
  "DRILLDOWN_LINE_LEVEL_1": "Perspectiva: <b class=\"text-primary\">Línea</b> - Producto - Presentación",
  "DRILLDOWN_LINE_LEVEL_2": "Perspectiva: Línea - <b class=\"text-primary\">Producto</b> - Presentación, Línea: {{level1}}",
  "DRILLDOWN_LINE_LEVEL_3": "Perspectiva: Línea - Producto - <b class=\"text-primary\">Presentación</b>, Línea: {{level1}}, Producto: {{level2}}",
  "DRILLDOWN_REGION_LEVEL_1": "Perspectiva: <b class=\"text-primary\">Región</b> - Provincia - Ciudad",
  "DRILLDOWN_REGION_LEVEL_2": "Perspectiva: Región - <b class=\"text-primary\">Provincia</b> - Ciudad, Región: {{level1}}",
  "DRILLDOWN_REGION_LEVEL_3": "Perspectiva: Región - Provincia - <b class=\"text-primary\">Ciudad</b>, Región: {{level1}}, Provincia: {{level2}}",

  "@HEATMAP": "Color Map Screen",
  "HEATMAP_HEADLINE": "Concentración <b class=\"text-primary text-italic\">{{type}}</b>, corte a <b class=\"text-primary text-italic\">{{dateFilter}}</b>. {{filterInformation}}",

  "@NOTIFICATIONS": "Notifications Pages",
  "NOTIF_HEADLINE": "Notificaciones",
  "NOTIF_SEARCH_PLACEHOLDER": "Buscar notificación",
  "NOTIF_SIDEBAR_TOTAL": "Todos",
  "NOTIF_SIDEBAR_STARRED": "Favoritos",
  "NOTIF_SIDEBAR_IMPORTANT": "Importantes",
  "NOTIF_SIDEBAR_DELETED": "Eliminados",
  "@TODO_NOTIFICATION": "ELIMINAR ESTAS QUE YA NO SE USAN",
  "NOTIFICATION_SIDEBAR_TOTAL": "Todos",
  "NOTIFICATION_SIDEBAR_STARRED": "Favoritos",
  "NOTIFICATION_SIDEBAR_IMPORTANT": "Importantes",
  "NOTIFICATION_SIDEBAR_DELETED": "Eliminados",

  "CONFIRMATION_STAKEHOLDER": "registrar información del cliente",
  "CONFIRMATION_REMOVE_APPOINTMENT": "eliminar la visita",
  "CONFIRMATION_REMOVE_ORDER": "eliminar el pedido",

  "CONTACT_US_OFFICE": "Nuestra Oficina",
  "CONTACT_US_SEND_EMAIL": "Envíanos un correo electrónico",

  "404_DESCRIPTION": "Parece que te perdiste navegando. Tal vez puedes intentar estos enlaces:",
  "404_PRINCIPAL_DESCRIPTION": "Regresa a tu página principal",
  "404_HELP_CENTER_DESCRIPTION": "Accede a la base de conocimiento",
  "404_CUSTOMER_SERVICE_DESCRIPTION": "Accede a la base de conocimiento",

  "SETTINGS_THEME": "Tema",
  "SETTINGS_SCALE": "Escala",
  "SETTINGS_ROTATE": "Rotación en móvil",

  "SCREEN": {
    "SETTINGS": {
      "LANGUAGE": {
        "LABEL": "Idioma",
        "SP": "Español",
        "EN": "English"
      },
      "FORMAT": {
        "LABEL": "Formato",
        "UNITS": "U / $ (Ej: $123,456.56)",
        "THOUSANDS": "Miles (Ej: 123.4k)",
        "MILLIONS": "Millones (Ej: 1.23M)"
      },
      "PRECISION": {
        "LABEL": "Precisión",
        "ZERO": "Cero",
        "ONE": "Uno",
        "TWO": "Dos"
      },
      "REFRESH_INFO": "Actualizar",
      "RESET_APP": "Reiniciar",
      "OFFLINE_APPOINTMENTS": "Visitas ({{quantity}})",
      "OFFLINE_ORDERS": "Pedidos ({{quantity}})"
    },
    "FORMS": {
      "AGENT": "Colab.",
      "CLIENT": "Cliente",
      "ADD_ITEM": "Agregar ítem",
      "ADD_PHOTO": "Agregar foto",
      "APPOINTMENT_DATE": "Fecha",
      "NEXT_APPOINTMENT_DATE": "Sig. visita",
      "APPOINTMENT_OBJECT": "Objetivo",
      "APPOINTMENT_OBJECTS": {
        "OBJ1": "Presentación Laboratorio",
        "OBJ2": "Visita Promocional",
        "OBJ3": "Acción Comercial",
        "OBJ4": "Siembra Producto",
        "OBJ5": "Recordatorio Producto",
        "OBJ6": "Verificación de Stock"
      },
      "DEPENDENT_NAME": "Dependiente",
      "DEPENDENTS_NUMBER": "Dependientes",
      "TURN_NUMBER": "Número turno",
      "ESCORT": "Acompañamiento",
      "COMPANIONS": "Acompañantes",
      "APPOINTMENT_COMPANIONS": {
        "COMP1": "Director Comercial",
        "COMP2": "Director Médico",
        "COMP3": "Gerente de Ventas",
        "COMP4": "Gerente de Producto",
        "COMP5": "Gerente Distrital",
        "COMP6": "APM"
      },
      "VEHICLE": "Vehículo",
      "ITEM": "Ítem",
      "TOTAL": "Total",
      "QUANTITY": "Qty",
      "BONIF": "Bon",
      "PVF": "PVF",
      "PVP": "PVP",
      "DISCOUNT": "Dsc",
      "ACTION": "Acción",
      "MEDICAL_SAMPLES": "Entrega de muestras",
      "CYCLE": "Ciclo",
      "ITEMS": "Ítems registrados",
      "PLACEHOLDER_CLIENT": "Ingrese el nombre del cliente",
      "PLACEHOLDER_CONTACT": "Ingrese el nombre de contacto",
      "PLACEHOLDER_COMMENTS": "Observaciones del {{value}}",
      "PLACEHOLDER_DEPENDENT": "Ingrese el nombre de dependiente",
      "PLACEHOLDER_ITEM": "Seleccione el ítem",
      "PLACEHOLDER_DISPATCHER": "Seleccione el despachador",
      "HISTORY": {
        "APPOINTMENTS": "Últimas {{quantity}} visitas realizados por <b class=\"text-primary\">{{agentName}}</b> a <b class=\"text-primary\">{{clientName}}</b>",
        "ORDERS": "Últimos {{quantity}} pedidos realizados por <b class=\"text-primary\">{{agentName}}</b> a <b class=\"text-primary\">{{clientName}}</b>"
      },
      "OFFLINE": {
        "APPOINTMENTS": "Visitas guardadas para sincronización",
        "ORDERS": "Pedidos guardados para sincronización por <b class=\"text-primary\">{{agentName}}</b>"
      },
      "ORDER": "Pedido",
      "APPOINTMENT": "Visita",
      "APPOINTMENT_ADD_STOCK": {},
      "APPOINTMENT_ADD_FACE": {
        "ADD_NEW_FACE": "Registro de Caras",
        "CURRENT": "Planograma",
        "WIN": "Ganadas",
        "BEFORE": "Foto Anterior Caras",
        "AFTER": "Foto Nuevas Caras",
        "LOCATION": "Ubicación Caras",
        "NEW_LOCATION": "Las caras se ganaron en el mes?",
        "PHOTO_BEFORE": "Antes",
        "PHOTO_AFTER": "Después"
      },
      "APPOINTMENT_ADD_DISPLAY": {
        "ADD_NEW": "Registro de Exhibición",
        "BEFORE": "Antes",
        "AFTER": "Después"
      },
      "APPOINTMENT_OFFLINE_MESSAGES": {
        "APPOINTMENTS": "En esta sección se despliegan las visitas/pedidos que están pendientes por sincronizar. Asegúrese se haya podido reestablecer la conexión a Internet y proceda a su sincronización con el botón grabar.",
        "NO_APPOINTMENTS": "En esta sección se desplegarán las visitas/pedidos que están pendientes por sincronizar. Al parecer ya ha sincronizado todos los pedidos/visitas.",
        "APPOINTMENT_TABLE_HEADING": "Visitas por sincronizar",
        "ORDER_TABLE_HEADING": "Pedidos por sincronizar"
      }
    }
  },

  "AI_P360_TITLE": "P360° IA Pharma Expert",
  "AI_P360_WELCOME": ":robot: ¡Hola! Soy P360° IA Pharma Expert, tu experto en IA Pharma. ¿En qué puedo ayudarte hoy?",
  "AI_P360_PLACEHOLDER": "Escribe tu consulta",
  "AI_P360_ERROR": "No pudimos obtener una respuesta de la consulta que ingresaste, toca aquí para volver a intentar.",

  "FULLNAME": "Nombre completo",
  "PERSON_TYPE": "Tipo de persona",
  "PERSON_INFLUENCE": "Nivel de influencia",

  "APPOINTMENT_SAMPLE": "Muestra",
  "APPOINTMENT_STOCK": "Stock",
  "APPOINTMENT_FACE": "Cara/Facing",
  "APPOINTMENT_TRAINING": "Capacitación",
  "APPOINTMENT_DISPLAY": "Exhibición",

  "CUSTOMER_DETAILS_ADD_SOCIAL_MEDIA": "Agregar",
  "CUSTOMER_DETAILS_EDIT_SOCIAL_MEDIA": "Editar",

  "@ADMIN_CAMPAIGNS": "Admin Campaign Pages",
  "ADMIN_CAMPAIGNS_SEARCH_PLACEHOLDER": "Buscar parrillas",

  "@SELLIN_PERFORMANCE": "Sellin Performance Page",
  "SELLIN_HTML_FULFILLMENT": "<span class=\"block\">%C({{icon}})</span><span class=\"block\">{{duration}}</span>",
  "SELLIN_HTML_PROJECTION": "<span class=\"block\">(+/-) Venta</span>",
  "SELLIN_HTML_SALES": "<span class=\"block\">Venta({{icon}})</span><span class=\"block\">{{duration}}</span>"
}
